export enum DraggableItemTypes {
  RECTANGLE = "rectangle",
}
